import { combineReducers } from "redux";
import { softwaresState } from "./softwaresReducers";

export const softwaresReducers = combineReducers({
  softwaresState: softwaresState,
});
